import { ValidatorProvider } from '@dofleini/validator';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

import { CACHE_KEY_LIST_ACTOR } from '@/modules/actors/contants/actor';
import ActorApiService from '@/modules/actors/services/ActorApiService';
import SelectElementCmp from '@/utils/SelectElementCmp';

const ActorsSelect = ({ value, onChange, filters, ...props }) => {
  const currentValue = value ? (typeof value === 'object' ? value._id : value) : null;
  
  const onRenderItem = useCallback(({ name }) => {
    return <div className="truncate">
      <div className="flex items-center truncate">
        <div className="font-semibold">{name}</div>
      </div>
    </div>;
  }, []);
  
  return (
    <>
      <div className={'w-full truncate'}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_ACTOR}
          filters={filters}
          service={ActorApiService}
          includeValue={value}
          value={currentValue}
          onChange={onChange}
          customItemRender={onRenderItem}
          customMapItem={(v) => ({ ...v, name: `${v.comercialName ? `(${v.comercialName})` : ''} ${v.name}` })}
          queryConfig={{ refetchOnWindowFocus: false }}
        />
      </div>
    </>
  );
};

ActorsSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  filters: PropTypes.object
};

export default memo(ActorsSelect);

export const renderCNAESelect = ({ formItemProps, field, form }) => {
  
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <ActorsSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
